/**
 * MUI Dialog onClose reasons that must not dismiss series scope/conflict dialogs
 * (backdrop click). Escape and other reasons still close.
 */
export function isSeriesDialogBackdropCloseReason(
  reason: "backdropClick" | "escapeKeyDown"
): boolean {
  return reason === "backdropClick";
}
